import { SET_USER_DATA, SET_COMMERCE_DATA, SET_LEGAL_ENTITY } from './onboarding/actionTypes';

import { dataLayerPush, hashUserId } from '../helpers/gtm';

const gtmMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    case SET_USER_DATA:
      const data = {};
      data.userID = hashUserId(action.payload.doc_number);
      if (typeof action.payload.activity.category === 'string')
        data.tipoGiroComercial = action.payload.activity.category;
      dataLayerPush(data);
      break;
    case SET_COMMERCE_DATA:
      const empresaUnDia =
        action.payload.one_day_company === 'true' || action.payload.one_day_company === true
          ? 'si'
          : 'no';
      dataLayerPush({ empresaUnDia });
      break;
    case SET_LEGAL_ENTITY:
      const tipoPersona = action.payload ? 'juridica' : 'natural';
      dataLayerPush({ tipoPersona });
      break;

    default:
      break;
  }
  return next(action);
};

export default gtmMiddleware;
